import { supabaseGestionPension as supabase } from '../config/settings/supabase-client'
import { getLogger } from '../core/debuggers'

const logger = getLogger('notification.js')

export const NOTIFICATIONS_PAGE_SIZE = 5

const assertUserId = (userId) => {
  if (!userId || typeof userId !== 'string') {
    throw new Error('userId is required to load notifications')
  }
}

/**
 * Fetch a page of notifications for the logged-in user only.
 */
export const fetchNotifications = async (
  userId,
  page = 0,
  pageSize = NOTIFICATIONS_PAGE_SIZE
) => {
  assertUserId(userId)

  const from = page * pageSize
  const to = from + pageSize - 1

  const { data, error, count } = await supabase
    .from('notifications')
    .select('*', { count: 'exact' })
    .eq('user_id', userId)
    .order('created_at', { ascending: false })
    .range(from, to)

  if (error) {
    logger.error('error:', error)
    throw error
  }

  // Defensive: never surface another user's rows even if RLS is misconfigured.
  const scoped = (data || []).filter((row) => row.user_id === userId)

  return {
    data: scoped,
    total: count ?? scoped.length,
    page,
    pageSize,
  }
}

/**
 * Update a notification status (e.g. unread → read) for the owning user only.
 */
export const updateNotificationStatus = async (id, status, userId) => {
  assertUserId(userId)

  const { data, error } = await supabase
    .from('notifications')
    .update({ status })
    .eq('id', id)
    .eq('user_id', userId)
    .select()
    .maybeSingle()

  if (error) {
    logger.error('updateNotificationStatus error:', error)
    throw error
  }

  if (!data) {
    throw new Error(
      'No se pudo actualizar la notificación. Verifica que exista una política RLS de UPDATE en notifications.'
    )
  }

  return data
}
